import React from 'react';

import mainStyle from "../../dashboard.module.scss";
import { useTheme } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

import LineChart from "components/LineChart";

import icn_line_chart from 'assets/images/icons/icn_line_chart.svg';

const UsageLineChart = ({ sortable, title, data, lineChartFormattedLegendName, lineChartUnitData }) => {
  const theme = useTheme();

  return (
    <div
      style={{ height: "250px" }}
      className={`main-card-content ${mainStyle["dndObj_card"]} ${sortable === true ? mainStyle["dndObj_edit"] : ""}`}
    >
      <div className={mainStyle['dndObj_title']}>
        <Box>
          <img src={icn_line_chart} alt="icn_line_chart" />
        </Box>
        <span style={{ marginLeft: '10px' }}>{title}</span>
      </div>
      {data.length > 0 && data.some(item => item.data.length > 0) ?
        <LineChart
          legendStyle={{ top: 0, right: 10 }}
          formattedLegendName={lineChartFormattedLegendName}
          lineChartData={data}
          unitData={lineChartUnitData}
          height="200px"
        /> :
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}>
          <Typography
            sx={{
              color: theme.palette.primary.greyThird,
              fontSize: theme.typography.customFontSize[2],
            }}>
            No data available
          </Typography>
        </Box>
      }
    </div>
  );
}

export default UsageLineChart;